<template>
  <Menu v-if="locales" v-slot="{ close }" as="div" class="relative mx-2 lg:flex-shrink-0">
    <div class="flex">
      <MenuButton class="relative flex text-base font-bold bg-white p-1 px-2 rounded-full">
        <div class="rounded-full">
          <CountryFlag :code="LOCALES[$i18n.locale]?.flag" />
        </div>
        <ChevronDownIcon class="h-4 self-center ml-1 stroke-2 stroke-black" />
      </MenuButton>
    </div>

    <MenuItems
      class="fixed w-full h-auto mt-5 lg:w-auto lg:h-auto lg:absolute lg:flex flex-col right-0 z-20 origin-top-right lg:rounded-md bg-background text-forecolor lg:shadow-lg lg:ring-1 lg:ring-black/5 overflow-hidden focus:outline-none">
      <div class="flex justify-between">
        <h3 class="text-xl font-bold px-4 py-2">{{ $t("Language") }}</h3>
        <button class="lg:hidden mr-5" @click="close">
          <XMarkIcon class="h-5" />
        </button>
      </div>
      <hr />
      <div class="py-2">
        <MenuItem v-for="locale of locales" :key="locale" v-slot="{ active }">
          <button class="w-full" :class="{ 'bg-primary text-btn-forecolor': active }" @click="switchLocale(locale)">
            <div class="px-4 py-2 text-left flex min-w-max justify-between gap-2 items-center">
              <CountryFlag :code="LOCALES[locale]?.flag" :country="LOCALES[locale]?.title" />
              <span class="grow">{{ LOCALES[locale]?.title }}</span>
              <CheckIcon v-if="$i18n.locale === locale" class="w-5" />
            </div>
          </button>
        </MenuItem>
      </div>
    </MenuItems>
  </Menu>
</template>

<script setup>
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { CheckIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import CountryFlag from "@/components/CountryFlag.vue";
import { setLocale } from "@xs2event/js-lib/util";
import { LOCALES, locales } from "./locales.js";
import { ChevronDownIcon } from "@heroicons/vue/24/solid";

const switchLocale = (option) => {
  setLocale(option);
};
</script>
